var $ = require('jquery');
var renderError = require('./functions/renderError');

$(document).ready(function() {
    $("#dialog-create-client-click").on('click', function(e) {
        e.preventDefault();

        let buttons = {};
        buttons[Translator.trans('Save')] = function(win) {
            $('.modal-content #create-loader').show();

            var form = $(".modal-content #formUserPersonRegister");
            if($('.modal-content #user_type').val() == 'company') {
                var form = $(".modal-content #formUserRegister");
            }

            var dataInput = form.serialize();
            var dataOutput;
            var uri =  form.attr('action');
            var method = form.attr('method');

            $.ajax({
                type: method,
                url: uri,
                data: dataInput,
                dataType: 'json',
                error: function(xhr, ajaxOptions, thrownError) {
                    // alert(thrownError);
                    alert(Translator.trans('There was error. Please try again later.'));
                },
                success: function(dataOutput) {
                    if ('success' == dataOutput.result.status) {
                        if (0 != dataOutput.result.error.errorArray) {
                            var errorlist = renderError(dataOutput.result.error.errorArray);

                            $(".modal-content .validateTips").html(errorlist);
                            $('.modal-content #create-loader').hide();
                        }
                        else {
                            // update client list
                            $.get(RoutingS1.generate('client'), function(html) {
                                $("#clients_list").html(html);

                                // update status bar (after client change)
                                $.get(RoutingS1.generate('refreshStatusBar'), function(html) {
                                    $("#status-bar").html(html);
                                    notify([
                                        '<b>',
                                        Translator.trans('Saved successfully.'),
                                        '</b>'
                                    ].join(''));
                                    win.closeModal();
                                });
                            });
                        }
                    }
                }
            });
        };
        buttons[Translator.trans('Close')] = function(win) {
            win.closeModal();
        };

        $.modal({
            content: $("#dialog-create-client").html(),
            title: Translator.trans('Add client'),
            maxWidth: 700,
            maxHeight: 450,
            resizable: false,
            onOpen: function() {
                $('.modal-content').attr('id', 'mns');

                var $formUserRegister = $('.modal-content #formUserRegister');
                var $formUserPersonRegister = $('.modal-content #formUserPersonRegister');
                var $aCompany = $(".modal-content #aCompany");
                var $aPerson = $(".modal-content #aPerson");

                $aCompany.on('click', function() {
                    $aCompany.parent().removeClass('active');
                    $aPerson.parent().addClass('active');
                    $formUserRegister.show();
                    $formUserPersonRegister.hide();
                    $('.modal-content #user_type').val('company');
                    return false;
                });

                $aPerson.on('click', function() {
                    $aPerson.parent().removeClass('active');
                    $aCompany.parent().addClass('active');
                    $formUserRegister.hide();
                    $formUserPersonRegister.show();
                    $('.modal-content #user_type').val('person');
                    return false;
                });

                $aCompany.trigger('click');

            },
            buttons: buttons
        });

    });

    $('body').on('click', '.dialog-edit-client-click', function(e) {
        e.preventDefault();
        var url = $(this).attr('rel');

        let buttons = {};
        buttons[Translator.trans('Save')] = function(win) {
            var form = $(".modal-content").find('form');

            // if form was not loaded yet
            if (!form.attr('action')) {
                return;
            }

            $('.modal-content #edit-loader').show();

            var dataInput = form.serialize();
            var dataOutput;
            var uri =  form.attr('action');
            var method = form.attr('method');

            $.ajax({
                type: method,
                url: uri,
                data: dataInput,
                dataType: 'json',
                error: function(xhr, ajaxOptions, thrownError) {
                    // alert(thrownError);
                    alert(Translator.trans('There was error. Please try again later.'));
                },
                success: function(dataOutput) {
                    if ('success' == dataOutput.result.status) {
                        if (0 != dataOutput.result.error.errorArray) {
                            var errorlist = renderError(dataOutput.result.error.errorArray);

                            $(".modal-content .validateTips").html(errorlist);
                            $('.modal-content #edit-loader').hide();
                        }
                        else {
                            // update client list
                            $.get(RoutingS1.generate('client'), function(html) {
                                $("#clients_list").html(html);

                                // update status bar (after client change)
                                $.get(RoutingS1.generate('refreshStatusBar'), function(html) {
                                    $("#status-bar").html(html);
                                    notify([
                                        '<b>',
                                        Translator.trans('Saved successfully.'),
                                        '</b>'
                                    ].join(''));
                                    win.closeModal();
                                });
                            });
                        }
                    }
                }
            });
        };
        buttons[Translator.trans('Close')] = function(win) {
            win.closeModal();
        };

        $.modal({
            content: $('#dialog-edit-client').html(),
            title: Translator.trans('Edit client'),
            maxWidth: 700,
            maxHeight: 450,
            resizable: false,
            onOpen: function() {
                $('.modal-content').attr('id', 'mns');

                $.get(url, function(html) {
                    $('.modal-content #edit-loader').hide();
                    $(".modal-content").append(html);
                });
            },
            buttons: buttons
        });

    });

});
